
import { Component, Vue } from 'vue-property-decorator';
import LookupMailbox from '@/components/UI/LookupMailbox.vue';

@Component({
  components: {
    LookupMailbox,
  },
})
export default class Mailbox extends Vue {
  public chips: string[] = [];
}
